module.exports = __webpack_public_path__ + "img/tica_logo_header.f330cc1c.svg";